import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import {Button} from '../../../../UI/Button/Button';
import {showPudoMap} from '../../../actions/pudo-actions';
import getDeliveryAddressAttribute from '../../../delivery-address/getDeliveryAddressAttribute';
import Translation from '../../../lang/Translation';
import {getSettings, isGuest} from '../../../selectors/selectors';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';
import Spinner from '../../ui/Spinner';
import SuccessIcon from '../../ui/svg/success.svg';
import CollectionSavedAddressText from './CollectionSavedAddressText';
import useStyles from './CollectionSavedAddress.styles';

export function CollectionSavedAddress(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const handleChange = () => {
    props.updateSelectedCollectionPoint(props.index);
    try {
      doMetric('selectDeliveryAddress', props.getDeliveryAddressAttribute());
    } catch (error) {
      Track.track(error);
    }
  };
  
  return (
    <div id={`CollectionSavedAddress-${props.index}`}>
      {props.isCollectionPointLoading && (
        <div className="CollectionSavedAddress__animation">
          <img className="CollectionSavedAddress__successIcon" src={SuccessIcon} alt="" />
          <span className="CollectionSavedAddress__spinnerWrapper"><Spinner size="extra-small" /></span>
        </div>
      )}
      <div
        className={`CollectionSavedAddress__container ${props.isCollectionPointLoading
          ? 'CollectionSavedAddress__container--loading'
          : ''}`}
      >
        {!props.isGuest && (
          <input
            disabled={props.disabled ? 'disabled' : ''}
            id={props.index}
            checked={props.checked}
            type="radio"
            name="CollectionSavedAddress"
            value={props.address?.addressId}
            className={`CollectionSavedAddress__radio ${props.radioInputHidden ? 'CollectionSavedAddress__radio--hidden' : ''}`}
            onChange={handleChange}
            data-test="CollectionSavedAddress__radio-input"
          />
        )}
        <CollectionSavedAddressText
          id={props.index}
          address={props.address}
          paddingLeft={!props.radioInputHidden}
        />
        {props.shouldUseNewCollectionOverlay && (
          <Button
            link
            className={classes.collectionOverlayButton}
            onClick={props.showPudoMap}
            data-test="collectionOverlayButton"
            leftAlign
          >
            <Translation>checkout.delivery.address.collect.button.change.store</Translation>
          </Button>
        )}
      </div>
    </div>
  );
}

CollectionSavedAddress.propTypes = {
  index: PropTypes.number.isRequired,
  address: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  isCollectionPointLoading: PropTypes.bool,
  lastIndex: PropTypes.number,
  isGuest: PropTypes.bool.isRequired,
  radioInputHidden: PropTypes.bool,
  updateSelectedCollectionPoint: PropTypes.func.isRequired,
  getDeliveryAddressAttribute: PropTypes.func.isRequired,
  shouldUseNewCollectionOverlay: PropTypes.bool.isRequired,
  showPudoMap: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  const isCollectionPointLoading = state.pudo.collectionPointLoading && (ownProps.lastIndex - 1 === ownProps.index);
  return {
    pudo: state.pudo,
    isCollectionPointLoading,
    isGuest: isGuest(state),
    shouldUseNewCollectionOverlay: !!getSettings(state)?.should_use_new_collection_overlay,
  };
}

CollectionSavedAddress.defaultProps = {
  radioInputHidden: false,
};

export default connect(mapStateToProps, {getDeliveryAddressAttribute, showPudoMap})(CollectionSavedAddress);
